import { Link } from "react-router-dom";

export default function HeroSection() {
  const handleScroll = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/04cbb03b50ca038815f708a3efe706af.jpg"
          alt="アイルランド・ダブリン"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-4 py-24">
        <div className="inline-block bg-emerald-600/80 text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-6 tracking-widest">
          🍀 IRELAND STUDY ABROAD
        </div>
        <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
          アイルランドで夢を見つけよう
        </h1>
        <p className="text-xl md:text-2xl text-emerald-100 font-medium mb-3">
          留学するなら、ヨーロッパの宝石へ
        </p>
        <p className="text-sm md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed mb-10">
          緑豊かな自然と温かい人々、本格的な英語環境。<br />
          ClassLive留学があなたのアイルランド留学を全力サポートします。
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="https://lstep.app/N5D3BZr"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-[#06C755] hover:bg-[#05b34c] text-white font-bold px-8 py-4 rounded-full text-base transition-all cursor-pointer whitespace-nowrap shadow-lg"
          >
            <i className="ri-line-line text-xl" />
            LINEで相談する
          </a>
          <Link
            to="/counseling"
            className="inline-flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white font-bold px-8 py-4 rounded-full text-base transition-all cursor-pointer whitespace-nowrap shadow-lg"
          >
            <i className="ri-calendar-check-line text-xl" />
            無料カウンセリング予約
          </Link>
        </div>

        {/* Stats */}
        <div className="mt-16 flex flex-wrap justify-center gap-8 md:gap-16">
          {[
            { num: "1万+", label: "留学サポート実績" },
            { num: "98%", label: "顧客満足度" },
            { num: "20+", label: "提携語学学校" },
            { num: "0円", label: "エージェント手数料" },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-3xl font-bold text-emerald-300">{s.num}</div>
              <div className="text-xs text-white/70 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/60 text-xs">SCROLL</span>
        <div className="w-5 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/60 text-lg" />
        </div>
      </div>
    </section>
  );
}
